import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./promission";
import "@/assets/styles/index.scss";

import ElementUI from "element-ui";
Vue.use(ElementUI);

// 保存原始的 window.open
const originalOpen = window.open;

// 重写 window.open
window.open = function (url, target, features) {
  if (
    url &&
    typeof url === "string" &&
    url.startsWith("/") &&
    !url.startsWith("//") &&
    !url.startsWith("/web/") &&
    !url.match(/^https?:\/\//)
  ) {
    // 添加前缀
    url = "/web" + url;
  }

  return originalOpen.call(this, url, target, features);
};

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
